<script setup lang="ts">
/** On Board — DR: Change of Secretary (선임/사임 반복 결의 + [[Signers]]). */
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import OnBoardLoopBlock from './OnBoardLoopBlock.vue';
import OnBoardIncludeToggle from './OnBoardIncludeToggle.vue';
import './onboardDoc.css';

const APPT_COLS = [
  { key: 'secretary_name', label: 'Name' },
  { key: 'secretary_identification_no', label: 'Identification No.' },
  { key: 'his_her', label: 'his/her' },
];
const RESIGN_COLS = [
  { key: 'secretary_name', label: 'Name' },
  { key: 'secretary_identification_no', label: 'Identification No.' },
  { key: 'effective_date', label: 'Effective Date' },
];
</script>

<template>
  <div class="agm-doc">
    <OnBoardIncludeToggle flag="include_dr_secretary" />
    <div class="doc-head">
      <div class="doc-title"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-sub">Company Registration No. <CddVarField field-key="company_registration_no" label="Reg. No." /></div>
      <div class="doc-sub">(Incorporated in the Republic of Singapore)</div>
      <div class="doc-sub">(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="sec-title center">DIRECTORS' RESOLUTIONS IN WRITING</div>
    <div class="doc-p center">PASSED PURSUANT TO THE COMPANY'S CONSTITUTION</div>

    <div class="sec-title">APPOINTMENT OF SECRETARY</div>
    <p class="doc-p">
      RESOLVED that each of the following persons be and is hereby appointed as Secretary of the Company with
      effect from the date of his/her written consent to act as such:
    </p>
    <div class="doc-p doc-note">Incoming secretary(ies). Rows from a Form 45B (Consent to Act as Secretary) are linked automatically; you can also add an incoming secretary here without a Form 45B.</div>
    <!-- Form 45B 연동 행(자동) + 직접 추가 행(appt_sec_m). -->
    <OnBoardLoopBlock prefix="appt_sec" :columns="APPT_COLS" :show-add="false" :show-remove="false" hide-empty />
    <OnBoardLoopBlock prefix="appt_sec_m" :columns="APPT_COLS" add-label="+ Add incoming (appointed) secretary" hide-empty />
    <p class="doc-p">RESOLVED that the Accounting and Corporate Regulatory Authority be notified accordingly.</p>

    <div class="sec-title">RESIGNATION OF SECRETARY</div>
    <p class="doc-p">
      RESOLVED that the resignation of each of the following persons as the secretary of the Company be
      accepted as from the respective effective date:
    </p>
    <div class="doc-p doc-note">Outgoing secretary(ies). Use ✨ on the name to pick the current secretary.</div>
    <OnBoardLoopBlock prefix="resign_sec" :columns="RESIGN_COLS" add-label="+ Add outgoing (resigning) secretary"
      empty-note="No secretary resignation." />
    <p class="doc-p">RESOLVED that the Accounting and Corporate Regulatory Authority be notified accordingly.</p>

    <div class="doc-meta">Dated: <CddVarField field-key="dr_resolution_date" label="Resolution Date" /></div>
    <AgmSigners var-key="dr_secretary_Signers" board-label="Directors" />
  </div>
</template>
